// extracted by mini-css-extract-plugin
export default {"main_container":"PaymentStatus_main_container__HI8le","title":"PaymentStatus_title__XuXbS","description":"PaymentStatus_description__5YIEF","btn":"PaymentStatus_btn__YpAmD"};